export default __webpack_public_path__ + "f9069c5bd77262de29850b55594f6f39.svg";